const countries = [
  { code: 'fr', name: 'France' }, { code: 'be', name: 'Belgium' }, { code: 'es', name: 'Spain' },
  { code: 'gb', name: 'United Kingdom' }, { code: 'it', name: 'Italy' }, { code: 'ca', name: 'Canada' },
  { code: 'us', name: 'USA' }, { code: 'de', name: 'Germany' }, { code: 'ch', name: 'Switzerland' },
  { code: 'pt', name: 'Portugal' }, { code: 'nl', name: 'Netherlands' }, { code: 'tn', name: 'Tunisia' },
  { code: 'ci', name: 'Ivory Coast' }, { code: 'cm', name: 'Cameroon' }, { code: 'sa', name: 'Saudi Arabia' },
];

const WorldCoverage = () => (
  <section className="py-12 sm:py-16 md:py-24 bg-gradient-to-b from-black via-gray-950 to-black relative overflow-hidden">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
      <div className="text-center mb-8 sm:mb-12">
        <div className="inline-flex items-center gap-2 bg-[#862ce0]/10 border border-[#862ce0]/20 rounded-full px-4 py-2 mb-4 sm:mb-6">
          <span className="text-sm font-medium text-[#b47ef3]">International Coverage</span>
        </div>
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 sm:mb-4 text-white">
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#862ce0] to-[#c026d3]">TV Streaming</span>
          <br />Everywhere in the World
        </h2>
        <p className="text-gray-400 text-base sm:text-lg md:text-xl max-w-3xl mx-auto leading-relaxed px-2">
          No matter where you are, our service is available internationally.
        </p>
      </div>
      <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
        {countries.map((c) => (
          <div key={c.code} className="flex flex-col items-center p-4 rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm hover:border-[#862ce0]/50 hover:bg-white/10 transition-all duration-300 group hover:scale-105 cursor-default">
            <img alt={c.name} className="w-16 h-12 object-cover rounded mb-2 group-hover:scale-110 transition-transform" loading="lazy" src={`https://flagcdn.com/w80/${c.code}.png`} />
            <span className="text-sm font-medium text-white">{c.name}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default WorldCoverage;
